const checkboxes = document.querySelectorAll('input[type="checkbox"][name="recommended_product_id"]');
checkboxes.forEach((checkbox) => {
  checkbox.addEventListener('change', (event) => {
    if (event.target.checked) {
      checkboxes.forEach((cb) => {
        if (cb !== event.target) {
          cb.checked = false;
        }
      });
    }
  });
});
document.querySelector(".float-add-to-cart-button").onclick = function () {
  let controls_id = this.getAttribute("data-controls")
  document.querySelector(`#${controls_id}`).show()
}
